import React, {useMemo} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {useHistory} from 'utils'
import {Button, Modal, Paragraph, RoboyuOffer} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'
import {GiftShopBalanceCreatePasswordModalProps} from './GiftShopBalanceCreatePasswordModalProps'

const StyledModal = styled(Modal)`
  width: 100%;
  max-width: ${convertUnit(295)};
  padding: ${convertUnit(20)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${convertUnit(12)};
  text-align: center;
`

const StyledRoboyuContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: ${convertUnit(114)};
  max-height: ${convertUnit(114)};
  display: flex;
  justify-content: center;
  align-self: center;
`
const StyledButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(8)};
`

const StyledButton = styled(Button)`
  width: 100%;
`

export default function GiftShopBalanceCreatePasswordModal({
  visible,
  toggleModal,
  desc,
  backToPage,
}: GiftShopBalanceCreatePasswordModalProps) {
  const {translate} = useTranslation()
  const history = useHistory()
  const {colorTheme} = useSelector('roboyuState')

  const handleRenderTitle = useMemo(
    () => (
      <Paragraph fontSize="l" fontWeight="bold">
        {translate('giftShop:createPassword')}
      </Paragraph>
    ),
    [translate],
  )

  // const handleRenderImage = useMemo(
  //   () => <StyledImage src={image} alt="image" />,
  //   [image],
  // )

  const handleRenderInfo = useMemo(
    () => (
      <Paragraph fontSize="m">
        {desc ?? translate('giftShop:addBankAccountCreatePasswordInfo')}
      </Paragraph>
    ),
    [desc, translate],
  )

  const handleRenderButton = useMemo(
    () => (
      <StyledButtonContainer>
        <StyledButton
          label={translate('giftShop:createPassword')}
          onClick={() =>
            history.push('giftshop_edit_profile', {
              menu: 'password',
              desc: backToPage,
            })
          }
        />
        <StyledButton
          label={translate('global:cancel')}
          backgroundColor="white_2"
          color="primary_5"
          onClick={toggleModal}
        />
      </StyledButtonContainer>
    ),
    [backToPage, history, toggleModal, translate],
  )

  return (
    <StyledModal visible={visible} onBackdropPress={toggleModal}>
      {handleRenderTitle}
      <StyledRoboyuContainer>
        <RoboyuOffer
          width={convertUnit(114)}
          height={convertUnit(114)}
          colorTheme={colorTheme.name}
        />
      </StyledRoboyuContainer>
      {handleRenderInfo}
      {handleRenderButton}
    </StyledModal>
  )
}
